import { useI18n } from '../lib/i18n';
import { useVehicles } from '../lib/queries';
import { Card, Skeleton } from '../components/ui';

export function GaragePage() {
  const { t } = useI18n();
  const { data, isPending } = useVehicles();
  const items = data?.items ?? [];

  return (
    <div>
      <h1 className="mb-4 font-display text-2xl font-bold tracking-tight text-ink">
        {t('garage.title')}
      </h1>

      {isPending && (
        <div className="space-y-2">{[0, 1].map((i) => <Skeleton key={i} className="h-20" />)}</div>
      )}

      {!isPending && items.length === 0 && (
        <Card className="py-10 text-center">
          <p className="text-sm text-ink-dim">{t('garage.empty')}</p>
        </Card>
      )}

      <div className="space-y-2">
        {items.map((vehicle) => (
          <Card key={vehicle.id}>
            <div className="text-base font-semibold text-ink">
              {vehicle.make} {vehicle.model}
            </div>
            <div className="tabular mt-1 text-xs text-ink-faint">
              {[vehicle.year, vehicle.licensePlate].filter(Boolean).join(' · ')}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
